import { Tooltip, styled, tooltipClasses } from '@mui/material';

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip
        {...props}
        classes={{ popper: className }}
        slotProps={{
            popper: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -10]
                        }
                    }
                ]
            }
        }}
    />
))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        color: '#000'
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: '#fff'
    }
}));

export default LightTooltip;
